// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bct_a bhm_ea bhm_ke bhm_ju bhm_sn bhm_wl"};